import type { EmojiPackId, EmojiSegment } from './types';

const PLACEHOLDER_REGEX = /\[e:(fluentui):([0-9a-fA-F-]+)\]/g;

export function encodeEmojiPlaceholder(codepoints: string) {
  return `[e:fluentui:${normalizeCodepoints(codepoints)}]`;
}

export function parseEmojiPlaceholders(text: string): EmojiSegment[] {
  if (!text) return [{ type: 'text', value: '' }];

  const segments: EmojiSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(PLACEHOLDER_REGEX)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, matchIndex) });
    }

    const pack = match[1] as EmojiPackId;
    const codepoints = normalizeCodepoints(match[2]);
    segments.push({ type: 'emoji', pack, codepoints, raw: match[0] });
    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  if (segments.length === 0) {
    return [{ type: 'text', value: text }];
  }

  return segments;
}

export function normalizeCodepoints(codepoints: string) {
  return codepoints.trim().toLowerCase();
}

export function codepointsToUnicode(codepoints: string) {
  const points = normalizeCodepoints(codepoints)
    .split('-')
    .filter(Boolean)
    .map((part) => Number.parseInt(part, 16))
    .filter((value) => !Number.isNaN(value));

  return String.fromCodePoint(...points);
}

export function unicodeToCodepoints(value: string) {
  return Array.from(value)
    .map((char) => char.codePointAt(0)?.toString(16))
    .filter((part): part is string => Boolean(part))
    .join('-');
}
